import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../services/event-capture';
import {
  addIncidentDescription,
  addIncidentVideo,
  selectIncidentDescription,
} from '../../../../services/store/modules/incident-report';
import { VideoUpload } from '../../../../services/store/modules/incident-report/models';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import IncidentDescriptionForm from '../components/IncidentDescriptionForm/IncidentDescriptionForm';
import useIncidentReportingLocation from '../hooks/useIncidentReportingLocation';

const IncidentDescriptionPage: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleVideoUpload = async (upload: VideoUpload) => {
    dispatch(
      addIncidentVideo({
        uploadId: upload.uploadId,
        url: upload.url,
        localFilePath: upload.localFilePath,
      }),
    );
    await captureEvent({
      type: 'incident: video uploaded',
      payload: {
        uploadId: upload.uploadId,
      },
    });
  };

  const [selectedLatitude, selectedLongitude] = useIncidentReportingLocation();
  const hydratedIncidentDetails = useSelector(selectIncidentDescription);

  const handleSubmit = async (data: {
    vesselRegistration: string;
    description: string;
    imageUrls: string[];
  }) => {
    dispatch(addIncidentDescription(data));
    await captureEvent({
      type: 'incident: additional details entered',
      payload: {},
      sendToAmplitude: true,
    });
    history.push('contact');
  };

  const handleBack = async () => {
    await captureEvent({
      type: 'incident: back to incident details',
      payload: {},
      sendToAmplitude: true,
    });
    history.goBack();
  };
  return (
    <BasicDrawerLayout
      showMapOverlay
      showMenuBar={false}
      heading="Report an incident"
      onBack={handleBack}
    >
      {selectedLatitude && selectedLongitude ? (
        <IncidentDescriptionForm
          hydratedIncidentDetails={hydratedIncidentDetails}
          onSubmit={handleSubmit}
          onVideoSelect={handleVideoUpload}
        />
      ) : null}
    </BasicDrawerLayout>
  );
};

export default IncidentDescriptionPage;
